import React from "react";
import "./testimonials.css";

import SwiperTestimonial from './SwiperTestimonial'



const testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Reviews</h5>
      <h2>Testimonials</h2>
      <SwiperTestimonial />
    </section>
  );
};

export default testimonials;
